import { Router, ActivatedRoute, Params } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import {DomSanitizer,SafeResourceUrl} from '@angular/platform-browser';
import { FaqService } from '../../shared/services/faq.service';
import { TranslateService } from '@ngx-translate/core';
import { AccountService } from '../../shared/services/account.service';

import { LanguageService } from '../../shared/services/language.service';
import { UtilsService } from '../../shared/services/utils.service';
import { AppService } from '../../shared/services/app.service';


@Component({
	selector: 'app-faq-page',
	templateUrl: './faq-page.component.html',
	styleUrls: ['./faq-page.component.scss'],
})
export class FaqPageComponent implements OnInit {
	public youtubeVideos = [];
	public youtubeVideosSansDuplicates = [];
	public documentations = [];

	public allFaq = [];
	public faqTags = [];

	public filteredFaq = [];
	public filteredYoutube = [];
	public filteredDocumentation = [];

	public actualLang = 'en';

	public search = '';
	public activeTag = null;

	// public featuredEvent = [
	// 	{
	// 		id: 0,
	// 		img: 'assets/faq-en-anthony-events.jpg',
	// 		date: this.translate.instant('Chaque jeudi'),
	// 		hour: '14h30 - 15h30',
	// 		language: this.translate.instant('Français / Anglais'),
	// 		location: this.translate.instant('Campus virtuel'),
	// 		signUpLink:
	// 			'https://communication.immersivefactory.com/registration-play-and-learn-conference-june-2021.html',
	// 		slides: [
	// 			{
	// 				src: 'assets/people/Anthony_Sapin.png',
	// 				name: this.translate.instant('Anthony SAPIN'),
	// 				job: this.translate.instant('Custom Success Manager chez Immersive Factory'),
	// 			},
	// 		],
	// 	},
	// ];
	// public slides: any = [];
	// public featuredEventId = 0;
	public videoSrc: SafeResourceUrl;

	public currentLang = null;

    downloadURL = "https://data.immfactory.com/documentation/"

	public faqSupport = [
		{
			id : "0",
			titre:{fr:"Casques VR", en:"VR Headsets"},
			icon: "assets/svg/vr-face-light.svg",
			devices: [
				{id:"0", name:"Pico Neo 3", img:"assets/materiel/Pico3", videos:["2"], downloads:[4,5,6,7], tags: ["4"]},
				{id:"1", name:"Meta Quest 2", img:"assets/materiel/Oculus_Quest2", videos:["1"], downloads:[13,14], tags: ["5"]},
				{id:"2", name:"HTC VIVE Focus 3", img:"assets/materiel/focus3", videos:["0"], downloads:[0,1,2,3], tags: ["6"]},
				{id:"3", name:"HTC VIVE Focus Plus", img:"assets/materiel/Vive", videos:["3"], downloads:[11,12], tags: ["7"]}
			],
			videos:[
				// {id:"0", playlistUrl:{fr:"PL52sjC8dlQZ_pM96yFGa7uXKacgGsitd3", en:"PL52sjC8dlQZ_pM96yFGa7uXKacgGsitd3"}},
				// {id:"1", playlistUrl:{fr:"PLdZNCZ4HzEmNYKfU142UW6Du35jyaUy30", en:"PLdZNCZ4HzEmPd74yb7TinJppyZHORExRl"}},
				// {id:"2", playlistUrl:{fr:"PLiqmzXfb0VXThxvEa5a0YwdmFS9W0OtEr", en:"PLiqmzXfb0VXQSrQ5IJ9aSzEJMSkaCr4q_"}},
				// {id:"3", playlistUrl:{fr:"PLdZNCZ4HzEmMigqQaWSn--fdYKhZBoShp", en:"PLdZNCZ4HzEmMigqQaWSn--fdYKhZBoShp"}}
			],
			downloads:[
                // Focus 3
				{
                    id:"0",
                    text: 'Configure the headset & install APKs directly on the VR headset',
                    lang : 'en',
                    link:"EN+-+Focus+3+-+Configure+the+headset+_+install+APKs+directly+on+the+VR+headset.pptx.pdf"
                },
                {
                    id:"1",
                    text: 'Configurer le casque et Installer directement sur le casque VR',
                    lang : 'fr',
                    link:"FR+-+Focus+3+-+Configurer+le+casque+et+Installer+directement+sur+le+casque+VR.pptx.pdf"
                },
                {
                    id:"2",
                    text: 'Configure the headset & install APKs with a computer',
                    lang : 'en',
                    link:"EN+-+Focus+3+-+Configure+the+headset+_+install+APKs+with+a+computer.pptx.pdf"
                },
                {
                    id:"3",
                    text: 'Configurer le casque et Installer les APKs avec un ordinateur',
                    lang : 'fr',
                    link:"FR+-+Focus+3+-+Configurer+le+casque+et+Installer+les+APKs+avec+un+ordinateur.pdf"
                },

                // Pico Neo 3
                {
                    id:"4",
                    text: 'Configure the headset & install APKs directly on the VR headset',
                    lang : 'en',
                    link:"EN+-+Pico+Neo+3+-+Configure+the+headset+_+install+APKs+directly+on+the+headset.pptx.pdf"
                },
                {
                    id:"5",
                    text: 'Configurer le casque et Installer directement sur le casque VR',
                    lang : 'fr',
                    link:"FR+-+Pico+Neo+3+-+Configurer+le+casque+et+Installer+directement+sur+le+casque+VR.pptx.pdf"
                },
                {
                    id:"6",
                    text: 'Configure the headset & install APKs with a computer',
                    lang : 'en',
                    link:"EN+-+Pico+Neo+3+-+Configure+the+headset+_+install+APKs+with+a+computer.pptx.pdf"
                },
                {
                    id:"7",
                    text: 'Configurer le casque et Installer les APKs avec un ordinateur',
                    lang : 'fr',
                    link:"FR+-+Pico+Neo+3+-+Configurer+le+casque+et+Installer+les+APKs+avec+un+ordinateur.pptx.pdf"
                },

                //Focus Plus
                {
                    id:"11",
                    text: 'Guide d\'utilisation',
                    lang : 'fr',
                    link:"User_guide_ImmersiveFactory-FR.pdf"
                },
                {
                    id:"12",
                    text: 'User guide',
                    lang : 'en',
                    link:"User_guide_ImmersiveFactory-US.pdf"
                },

                //Quest 2
                {
                    id:"13",
                    text: 'Configurer le casque et Installer les APKs avec un ordinateur',
                    lang : 'fr',
                    link:"FR+-+Meta+Quest+2+-+Configurer+le+casque+et+Installer+les+APKs+avec+un+ordinateur.pdf"
                },
                {
                    id:"14",
                    text: 'Configure the headset & install APKs with a computer',
                    lang : 'en',
                    link:"EN+-+Meta+Quest+2+-+Configure+headset+and+install+APK+with+a+computer.pdf"
                },
			],
			questionTags: ["4","5","6","7"]
		},
		{
			id : "1",
			titre:{fr:"SafetyBox VR et Abonnement", en:"SafetyBox VR and Subscription"},
			icon: "assets/svg/catalog.svg",
			videos:[
				// {id:"0", playlistUrl:{fr:"PLdZNCZ4HzEmPrHBPjmoe6IpfGDKlSCB_0", en:"PLdZNCZ4HzEmPrHBPjmoe6IpfGDKlSCB_0"}}
			],
			downloads:[
                {
                    id:"8",
                    text: 'Immersive License - Usage guide',
                    lang : 'en',
                    link:"EN+-+Usage+guide+-+Immersive+License.pdf"
                },
                {
                    id:"9",
                    text: 'Immersive License - Guide d\'utilisation',
                    lang : 'fr',
                    link:"FR+-+Guide+d'utilisation+-+Immersive+License.pdf"
                },
                {
                    id:"10",
                    text: 'SafetyBox VR - Usage guide',
                    lang : 'en',
                    link:"EN+-+Usage+guide+-+SafetyBoxVR.pdf"
                },
                {
                    id:"11",
                    text: 'SafetyBox VR - Guide d\'utilisation',
                    lang : 'fr',
                    link:"FR+-+Guide+d'utilisation-+SafetyBoxVR.pdf"
                }
            ],
			questionTags: ["1"]
		},
		// {
		// 	id : "2",
		// 	titre:{fr:"SafetyBox VR", en:"SafetyBox VR"},
		// 	icon: "assets/svg/box.svg",
		// 	downloads:[],
		// 	questionTags: ["7"]
		// },
		// {
		// 	id : "3",
		// 	titre:{fr:"Formateurs", en:"Trainers"},
		// 	icon: "assets/svg/graduation-light.svg",
		// 	videos:[
		// 		// {id:"1", playlistUrl:{fr:"PLG_uQlJgy_dBvM7W8ThicL2q8QCXqEOTJ", en:"PLG_uQlJgy_dDt9EKe4te80IaJrUX7wLlg"}}
		// 	],
		// 	downloads:[],
		// 	questionTags: ["6"]
		// },
		{
			id : "2",
			titre:{fr:"Université", en:"University"},
			icon: "assets/svg/vr-face-light2.svg",
			videos:[
				{id:"1", playlistUrl:{fr:"PLG_uQlJgy_dBvM7W8ThicL2q8QCXqEOTJ", en:"PLG_uQlJgy_dDt9EKe4te80IaJrUX7wLlg"}}
			],
			downloads:[],
			questionTags: ["8"]
		}
	]

	public menuId
	public deviceId

	public routeSub:any = null;
	public routeSubFragment:any = null;

	public recherche = false;
	public searchText

	public filteredTags = []



	constructor(
		public faqService: FaqService,
		public sanitizer: DomSanitizer,
		public translate: TranslateService,
		public accountService: AccountService,
		public language: LanguageService,
		public utilsService: UtilsService,
		public router: Router,
		public activatedRoute: ActivatedRoute,
		public appService: AppService
	) {}

	ngOnInit(): void {
		// this.slides = this.featuredEvent[this.featuredEventId].slides;
		this.getCurrentLang();
		this.getCategoryById();
		this.videoSrc = this.sanitizer.bypassSecurityTrustResourceUrl('');
	}

	ngOnDestroy() {
	  this.routeSub.unsubscribe();
		this.routeSubFragment.unsubscribe();
	}


	enterPressSearch(){
		let url;
		url = this.language.navigateAccordingToLang(['/faq']);
		this.router.navigate([url[0]],{queryParams: {'search': this.search}});
	}


	// WE GET THE SELECTED CATEGORY BY ITS ID IN THE TAGS URL
	getCategoryById() {
		this.routeSub = this.activatedRoute.queryParams.subscribe(params => {
			if(!params['search']){
				this.recherche = false;
				if(params['tags']){
					this.menuId = params['tags'];
					if(!this.faqSupport[this.menuId]?.devices){
						this.deviceId = "0";
						this.refreshContent();
					}
				}
				else{
					this.menuId = "0";
				}
			}
			else{

                this.search = params['search']
				this.searchText = params['search'];
				this.recherche = true;
				this.refreshContentSearch();
			}
			if(!params['tags'] && !params['search']){
				this.menuId = "0";
				this.deviceId = "0";
				this.refreshContent();
			}
		});
		this.routeSubFragment = this.activatedRoute.fragment.subscribe(fragments => {
			if(fragments){
				this.deviceId = fragments;
				if(this.faqSupport[this.menuId]?.devices){
					this.refreshContent();
				}
			}
			else{
				this.deviceId = "0";
			}
		});
	}


refreshYoutubePlaylist() {
	this.youtubeVideos = [];
	if(this.menuId){
		if(!this.faqSupport[this.menuId]?.devices && this.faqSupport[this.menuId]?.videos){
			for(let playlist of this.faqSupport[this.menuId].videos){
				this.faqService
				.getYoutubePlaylist(playlist.playlistUrl[this.translate.store.currentLang])
				.then((results) => {
					this.youtubeVideos.push(results);
				});
			}
		}
		if(this.deviceId){
			if(this.faqSupport[this.menuId]?.devices && this.faqSupport[this.menuId]?.videos && this.faqSupport[this.menuId]?.devices[this.deviceId]?.videos){
				for(let playlist of this.faqSupport[this.menuId].videos){
					for(let playlistId of this.faqSupport[this.menuId]?.devices[this.deviceId].videos){
						if(playlist.id == playlistId){
							this.faqService
							.getYoutubePlaylist(playlist.playlistUrl[this.translate.store.currentLang])
							.then((results) => {
								this.youtubeVideos.push(results);
							});
						}
					}
				}
			}
		}
	}
}


refreshDocumentation() {
	this.documentations = [];
	if(this.menuId){
		if(!this.faqSupport[this.menuId]?.devices && this.faqSupport[this.menuId]?.downloads) {
			for(let doc of this.faqSupport[this.menuId]?.downloads){
				this.documentations.push(doc);
			}
		}
		if(this.deviceId){
			if(this.faqSupport[this.menuId]?.devices && this.faqSupport[this.menuId]?.downloads && this.faqSupport[this.menuId]?.devices[this.deviceId]?.downloads){
				for(let doc of this.faqSupport[this.menuId]?.downloads){
					for(let docID of this.faqSupport[this.menuId]?.devices[this.deviceId]?.downloads){
						if(doc.id == docID){
							this.documentations.push(doc);
						}
					}
				}
			}
		}
	}
    this.documentations = this.documentations.filter((doc) => doc.lang == this.translate.store.currentLang.toString().toLowerCase()).map(e => ({...e,link : this.downloadURL+e.link}));
}


refreshFaq() {
	this.faqService.getAllFaqs().then((tags) => {
	this.faqTags = [];
	this.allFaq = [];
	for (let tag of tags) {
			if(this.deviceId){
				if(this.faqSupport[this.menuId]?.devices && this.faqSupport[this.menuId]?.questionTags.length > 0){
					if (tag.id && this.menuId) {
					for(let menuTag of this.faqSupport[this.menuId]?.questionTags){
						for(let deviceTag of this.faqSupport[this.menuId]?.devices[this.deviceId].tags){
							if (deviceTag == menuTag && deviceTag == tag.id){
								this.faqTags.push(tag);
								for (let faq of tag.faqs) {
									var newTag = faq;
									newTag['tagInfos'] = tag;
									this.allFaq.push(newTag);
								}
							}
						}
					}
				}
			}
			else{
				for(let menuTag of (this.faqSupport[this.menuId]?.questionTags ?? [])){
					if(menuTag == tag.id){
						this.faqTags.push(tag);
						for (let faq of tag.faqs) {
							var newTag = faq;
							newTag['tagInfos'] = tag;
							this.allFaq.push(newTag);
						}
					}
				}
			}
		}
		}
		this.filteredFaq = [];
		this.filteredFaq = this.allFaq;
	});
}


refreshContent(){
	this.activeTag = null;
	this.refreshYoutubePlaylist();
	this.refreshDocumentation();
	this.refreshFaq();
	this.search = '';
}


filterFaq(tag = this.activeTag) {
	this.filteredFaq = [];
	if (!tag) {
			this.filteredFaq = this.allFaq;
	} else {
			this.filteredFaq = this.allFaq.filter((faq) => faq.tag == tag);
		}
	}


refreshSearchTags(){
	return new Promise((resolve)=>{
		this.faqService.getAllFaqs().then((tags) => {
			this.faqTags = [];
			this.allFaq = [];
			let i = 1;
			for (let tag of tags) {
				i++;
				if (tag.id) {
					this.faqTags.push(tag);
					let k = 0;
					for (let faq of tag.faqs) {
						k++;
						var newTag = faq;
						newTag['tagInfos'] = tag;
						this.allFaq.push(newTag);
					}
				}
			}
            resolve(0)
		})
	})
}


refreshSearchDocumentations(){
	return new Promise((resolve)=>{
		this.documentations = [];
		let i = 0;
		for(let menu of this.faqSupport){
			i++;
			if(menu.downloads && menu.downloads.length>0){
				let j = 0;
				for(let doc of menu.downloads){
					this.documentations.push(doc);
					j++;
					if(i==this.faqSupport.length && j==menu.downloads.length){
						resolve(this.documentations);
					}
				}
			}
			else{
				if(i==this.faqSupport.length){
					resolve(this.documentations);
				}
			}
		}
	})
}

refreshSearchVideos(){
	return new Promise((resolve)=>{
		this.youtubeVideos = [];
		let i = 0;
		for(let menu of this.faqSupport){
			i++;
			if(menu.videos && menu.videos.length>0){
				let j = 0;
				for(let playlist of menu.videos){
					if(i==this.faqSupport.length){
						j++
					};
					let k = 0;
					this.faqService
					.getYoutubePlaylist(playlist.playlistUrl[this.translate.store.currentLang])
					.then((results) => {
						for(let item of results){
							k++;
							this.youtubeVideos.push(item);
							if(j==menu.videos.length && k==results.length){
								resolve(this.youtubeVideos);
							}
						}
					});
				}
			}
			else{
				if(i==this.faqSupport.length){
					resolve(this.youtubeVideos);
				}
			}
		}
	})
}

checkVideosDuplicate(youtubeVideos){
	var filteredArray = youtubeVideos.reduce((acc, video) => {
    if (!acc.find(u => u.title === video.title)) {
        acc.push(video)
    }
    return acc
	}, []);
	return filteredArray;
}

checkDocumentationsDuplicate(documentations){
	var filteredArray = documentations.reduce((acc, doc) => {
    if (!acc.find(u => u.link === doc.link)) {
        acc.push(doc)
    }
    return acc
	}, []);
	return filteredArray;
}

checkTagsDuplicate(){
	var filteredArray = this.filteredTags.reduce((acc, tag) => {
    if (!acc.find(u => u.id === tag.id)) {
        acc.push(tag)
    }
    return acc
	}, []);
	return filteredArray;
}


refreshContentSearch(){
	this.activeTag = null;
	this.refreshSearchVideos()
    .then((results) => {
		this.youtubeVideosSansDuplicates = this.checkVideosDuplicate(this.youtubeVideos);
		this.refreshSearchDocumentations()
        .then((results) => {
			this.documentations = this.checkDocumentationsDuplicate(this.documentations);
            this.documentations = this.documentations.filter((doc) => doc.lang == this.translate.store.currentLang.toString().toLowerCase());
			this.refreshSearchTags()
            .then(() => {
				this.filterTags();
			})
		})
	})
}

filterTags(tag = this.activeTag, searchString = this.searchText) {
	this.filteredFaq = [];
	this.filteredYoutube = [];
	this.filteredDocumentation = [];

	if (!tag) {
		this.filteredTags = [];
		if (searchString) {
				this.filteredFaq = this.allFaq.filter(
					(faq) =>
					faq.quest[this.translate.store.currentLang]
					.toLowerCase()
					.includes(searchString.toLowerCase())
					// ||
					// faq.rep[this.translate.store.currentLang]
					// .toLowerCase()
					// .includes(searchString.toLowerCase())
				);
				for(let tag of this.faqTags){
					for(let faq of this.filteredFaq)
					if(tag.id == faq.tag){
						this.filteredTags.push(tag);
					}
				}
				this.filteredTags = this.checkTagsDuplicate();
				this.filteredYoutube = this.youtubeVideosSansDuplicates.filter(
					(youtube) =>
					youtube.title
					.toLowerCase()
					.includes(searchString.toLowerCase())
				);
				this.filteredDocumentation = this.documentations.filter((doc) => doc.lang == this.translate.store.currentLang.toString().toLowerCase());
		}
	} else {
		if (searchString) {
			for(let tag of this.faqTags){
				for(let faq of this.filteredFaq)
				if(tag.id == faq.tag){
					this.filteredTags.push(tag);
				}
			}
			this.filteredFaq = this.allFaq.filter(
				(faq) =>
				faq.tag == tag &&
				(faq.quest[this.translate.store.currentLang]
					.toLowerCase()
					.includes(searchString.toLowerCase()))
					// ||
					// faq.rep[this.translate.store.currentLang]
					// .toLowerCase()
					// .includes(searchString.toLowerCase()))
				);
					this.filteredYoutube = this.youtubeVideosSansDuplicates.filter(
						(youtube) =>
						youtube.title
						.toLowerCase()
						.includes(searchString.toLowerCase())
					);
					this.filteredDocumentation = this.documentations.filter((doc) => doc.lang == this.translate.store.currentLang.toString().toLowerCase());
			}
		}
}





			getCurrentLang() {
				this.currentLang = this.translate.store.currentLang;
			}

			video(url) {
				this.videoSrc = this.sanitizer.bypassSecurityTrustResourceUrl(
					'https://www.youtube.com/embed/' +
					url +
					'?autoplay=1&amp;modestbranding=1&amp;showinfo=0'
				);

				var modal = document.querySelector('.modal');
				var container = modal.querySelector('.modal-content');

				// Check if we click outside the modal in order to stop the video
				document
				.querySelector('.modal')
				.addEventListener('click', function (e) {
					if (e.target !== container) {
						document.getElementById('video').setAttribute('src', '');
					}
				});
			}



		}
